// images
import { flagsIcon, loginImage } from './images';

/** Project Default Name */
export const PROJECT_NAME = 'Fadhili Gas Increment Program';

/** PKG No */
export const PKG_1 = 'pkg1';
export const PKG_2 = 'pkg2';
export const PKG_4 = 'pkg4';

/**
 * 페이지네이션 넘버
 */
export const STICKY_TABLE_PAGE_VIEW = [5, 20, 50, 100, 200, 250, 500, 1000];
export const DEFAULT_PAGE_COUNT = 100;
export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 50;

/** Swiper Speed */
export const DEFAULT_SWIPER_SPEED = 500;

/** CountUp Duration */
export const COUNT_UP_DURATION = 3;

/** 10분 */
export const TEN_MINUTES = 10 * 60 * 1000;

export const PTW_SWIPER_SPEED = 500;

/**
 * 로그인 배경 이미지
 */
export const loginImages = [
  {
    src: loginImage.image1
  },
  {
    src: loginImage.image2
  },
  {
    src: loginImage.image3
  }
];

/**
 * 데이트 포맷 형식
 */
export const DEFAULT_DATE_FORTMAT = 'YYYY-MM-DD';
export const DEFAULT_SHORT_DATE_FORMAT = 'YY-MM-DD';
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DD';

export const DEFAULT_TIME_FORMAT = 'HH:mm';

export const DEFAULT_DATE_FORMAT_V2 = 'DD-MMM-YYYY';
export const DEFAULT_DATE_FORMAT_V2_DASH = 'DD-MMM-YYYY';
export const DEFAULT_DATE_TIME_FORMAT_V4 = 'DD-MMM-YYYY HH:mm:ss';
export const DATE_TIME_FORMAT_LONG = 'HH:mm:ss DD-MMM-YYYY';
export const DATE_TIME_FORMAT_MONTH = 'MMM-YYYY';

// Open Weather Map Icon
export const OPEN_WEATHER_MAP_ICON_ID = '#{WEATHER_ICON}';
export const OPEN_WEATHER_ICON = `https://openweathermap.org/img/wn/${OPEN_WEATHER_MAP_ICON_ID}@4x.png`;

/** Flag Type */
export const flagType = {
  green: {
    title: 'Caution 25℃ ~ 29℃',
    content: ['As normal, No limit', 'Drink 1 Cup Water Every 20 Minutes.'],
    src: flagsIcon.green,
    value: 'ENVIRONMENTAL_GREEN'
  },
  yellow: {
    title: 'Extream Caution 30℃ ~ 38℃',
    content: ['50 minutes Work and 10 minutes Rest', 'Drink 1 Cup Water Every 20 Minutes.'],
    src: flagsIcon.yellow,
    value: 'ENVIRONMENTAL_YELLOW'
  },
  orange: {
    title: 'Danger 39℃ ~ 51℃',
    content: ['30 minutes Work and 10 minutes Rest', 'Drink 1 Cup Water Every 15 Minutes.'],
    src: flagsIcon.orange,
    value: 'ENVIRONMENTAL_ORANGE'
  },
  red: {
    title: 'Extreme Danger 52℃ ~ ABOVE',
    content: ['20 minutes Work and 10 minutes Rest', 'Drink 1 Cup Water Every 10 Minutes.'],
    src: flagsIcon.red,
    value: 'ENVIRONMENTAL_RED'
  }
};

/** Map Dashboard Type */
export const mapDashboardType = [
  {
    value: 'work-location',
    label: 'Work Location'
  },
  {
    value: 'risk-assessment',
    label: 'Risk Assessment'
  },
  {
    value: 'non-conformance',
    label: 'Non-Conformance'
  },
  {
    value: 'permit-to-work',
    label: 'Permit to Work'
  }
];

/** Mutation의 커스텀 옵션의 기본값 */
export const customMutationInitialOptions = {
  disableLoading: false,
  disableToast: false,
  successMessage: null,
  errorMessage: null,
  invalidateQueryKey: true,
  rollbackOptimistic: true,
  afterError: () => {},
  afterSuccess: () => {},
  commonCallback: () => {}
};
